// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QnOQ","placeholdersHeader":"styles_placeholdersHeader__3L6rn","editorStyle":"styles_editorStyle__iJQiL","placeholdersBox":"styles_placeholdersBox__2XSMq"};